import { Clock, CheckCircle, XCircle, Ban, FileText, Package, PackageCheck, PackageX, PackageMinus, CreditCard, Archive, Undo2 } from 'lucide-react';

const statusConfig = {
  draft: {
    label: 'Draft',
    className: 'bg-slate-100 text-slate-700 border-slate-200',
    icon: FileText
  },
  submitted: {
    label: 'Submitted',
    className: 'bg-amber-50 text-amber-700 border-amber-200',
    icon: Clock
  },
  approved: {
    label: 'Approved',
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    icon: CheckCircle
  },
  rejected: {
    label: 'Rejected',
    className: 'bg-rose-50 text-rose-700 border-rose-200',
    icon: XCircle
  },
  paid: {
    label: 'Terbayar',
    className: 'bg-emerald-100 text-emerald-800 border-emerald-300',
    icon: CheckCircle
  },
  sebagian_terbayar: {
    label: 'Sebagian Terbayar',
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    icon: CreditCard
  },
  cancelled: {
    label: 'Dibatalkan',
    className: 'bg-slate-200 text-slate-600 border-slate-300',
    icon: Ban
  },
  closed: {
    label: 'Ditutup',
    className: 'bg-slate-700 text-white border-slate-800',
    icon: Archive
  },
  returned: {
    label: 'Dikembalikan',
    className: 'bg-orange-100 text-orange-800 border-orange-300',
    icon: Undo2
  },
  // Gudang status
  diterima: {
    label: 'Diterima',
    className: 'bg-green-50 text-green-700 border-green-200',
    icon: PackageCheck
  },
  diterima_adj: {
    label: 'Diterima (Adj)',
    className: 'bg-yellow-50 text-yellow-700 border-yellow-200',
    icon: Package
  },
  diterima_partial: {
    label: 'Diterima Partial',
    className: 'bg-orange-50 text-orange-700 border-orange-200',
    icon: PackageMinus
  },
  reject: {
    label: 'Reject',
    className: 'bg-red-50 text-red-700 border-red-200',
    icon: PackageX
  },
  // AP status
  proses_bayar: {
    label: 'Proses Bayar',
    className: 'bg-indigo-50 text-indigo-700 border-indigo-200',
    icon: CreditCard
  },
  // Bank process status
  bank_process: {
    label: 'Diproses Bank',
    className: 'bg-purple-50 text-purple-700 border-purple-200',
    icon: CreditCard
  },
  terbayar: {
    label: 'Terbayar',
    className: 'bg-green-100 text-green-800 border-green-300',
    icon: CheckCircle
  },
  selected: {
    label: 'Selected (Bank)',
    className: 'bg-blue-50 text-blue-700 border-blue-200',
    icon: CreditCard
  },
  exported: {
    label: 'Exported (Bank)',
    className: 'bg-teal-50 text-teal-700 border-teal-200',
    icon: FileText
  },
  uploaded: {
    label: 'Uploaded (Bukti)',
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    icon: CheckCircle
  }
};

export default function StatusBadge({ status }) {
  const config = statusConfig[status] || statusConfig.draft;
  const Icon = config.icon;
  
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-medium border ${config.className}`}
    >
      <Icon size={14} />
      {config.label}
    </span>
  );
}

